
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/donate",
      function () {
        return require("private-next-pages/events/[eventId]/donate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/donate"])
      });
    }
  